// src/components/Detail/ProductInfo.js

import React from 'react';
import moneda from '../moneda';

const ProductInfo = ({ producto }) => {
    return (
        <>
            <h1 className="modern-product-title">{producto.titulo}</h1>
            <div className="modern-product-sku">SKU: {producto.idProducto}</div>
              {producto.descripcion && (
                <div className="modern-additional-info">
                    <p>{producto.descripcion}</p>
                </div>
            )}
            <div className='modern-price-section'>
                <div className="modern-price">
                    {moneda} {Number(producto.precio).toLocaleString('es-CO')}
                </div>
                {producto.precioAnterior > 0 && (
                    <div className='modern-old-price'>
                        {moneda} {Number(producto.precioAnterior).toLocaleString('es-CO')}
                    </div>
                )}
            </div>

          
        </>
    );
};

export default React.memo(ProductInfo);